import { Box, Typography, Stack, Grid } from '@mui/material';
import { useTranslation, Trans } from 'react-i18next';
import Search from './Search';

function FindProduct() {
  const { t } = useTranslation();

  return (
    <Box sx={{ my: 5 }}>
      {' '}
      {/* 80135463 */} {/* 8076800195057 */} {/* Codice Prodotto Test più completi */}
      <Stack direction="column" spacing={5} alignItems="center" justifyContent="center">
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <img src="favicon.svg" alt="logo" width="90" height="90" />
          <Typography variant="h4" align="center" sx={{ mt: 1 }}>
            Food Advisor
          </Typography>
        </Grid>
        <Search location="home" />
        <Stack>
          <Typography component="h1" variant="h4" align="center" sx={{ textTransform: 'capitalize' }}>
            {t('home.heading')}
          </Typography>
          <Typography variant="body1" align="center" sx={{ mt: 4, lineHeight: '120%' }}>
            <Trans i18nKey="home.subheading" />
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
}

export default FindProduct;
